const normalizeTeamIds = selectedTeams => Array.isArray(selectedTeams)
    ? selectedTeams
    : (selectedTeams ? [selectedTeams] : [])

const getUsersBySelectedTeams = (selectedTeams, users = [], teams = [], initialData = [], orCompare = () => false) => {
    const teamIds = normalizeTeamIds(selectedTeams)
    if (!teamIds.length) return [...initialData, ...users]

    const selectedTeamIds = new Set(teamIds.map(value => value?.toString()))
    const teamUserIds = new Set(
        teams
            .filter(team => selectedTeamIds.has(team.id?.toString()))
            .flatMap(team => (team.users || []).map(user => user.user_id?.toString()))
            .filter(Boolean)
    )

    return [
        ...initialData,
        ...users.filter(user => orCompare(user) || teamUserIds.has(user.id?.toString())),
    ]
}

const getValidUserIdsByTeams = (selectedUsers, selectedTeams, users, teams, alwaysAllowed = [], previousSelectedTeams) => {
    const normalizedSelectedUsers = Array.isArray(selectedUsers) ? selectedUsers : []
    const selectedUserIds = new Set(normalizedSelectedUsers.map(value => value?.toString()))
    const availableUsers = getUsersBySelectedTeams(selectedTeams, users, teams)

    if (previousSelectedTeams !== undefined) {
        const previousAvailableUsers = getUsersBySelectedTeams(previousSelectedTeams, users, teams)
        const allPreviousUsersWereSelected = previousAvailableUsers.length > 0
            && previousAvailableUsers.every(user => selectedUserIds.has(user.id?.toString()))

        if (allPreviousUsersWereSelected) {
            const selectedAlwaysAllowed = alwaysAllowed.filter(value => selectedUserIds.has(value?.toString()))
            return [...availableUsers.map(user => user.id), ...selectedAlwaysAllowed]
        }
    }

    const allowedUserIds = new Set([
        ...availableUsers.map(user => user.id),
        ...alwaysAllowed,
    ].map(value => value?.toString()))

    return normalizedSelectedUsers
        .filter(userId => allowedUserIds.has(userId?.toString()))
}

export { getUsersBySelectedTeams, getValidUserIdsByTeams }
